import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import './OnPageNavigation.css'

const OnPageNavigation = () => {
  const [headings, setHeadings] = useState([])
  const [activeId, setActiveId] = useState('')
  const location = useLocation()

  useEffect(() => {
    const content = document.querySelector('.docs-content')
    if (!content) return

    const headingElements = content.querySelectorAll('h2, h3')
    const headingData = Array.from(headingElements).map((heading) => {
      const id = heading.id || heading.textContent.toLowerCase().replace(/\s+/g, '-')
      if (!heading.id) {
        heading.id = id
      }
      return {
        id,
        text: heading.textContent,
        level: heading.tagName.toLowerCase()
      }
    })

    setHeadings(headingData)

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id)
          }
        })
      },
      {
        rootMargin: '-20% 0% -35% 0%',
        threshold: 0
      }
    )

    headingElements.forEach((heading) => observer.observe(heading))

    return () => {
      headingElements.forEach((heading) => observer.disconnect())
    }
  }, [location])

  const scrollToHeading = (id) => {
    const element = document.getElementById(id)
    if (element) {
      const offset = 100
      const elementPosition = element.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.pageYOffset - offset

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
    }
  }

  if (headings.length === 0) {
    return null
  }

  return (
    <aside className="onpage-navigation">
      <nav className="onpage-nav">
        <div className="onpage-nav-title">On this page</div>
        <ul className="onpage-nav-list">
          {headings.map((heading) => (
            <li key={heading.id} className={`onpage-nav-item ${heading.level}`}>
              <a
                href={`#${heading.id}`}
                onClick={(e) => {
                  e.preventDefault()
                  scrollToHeading(heading.id)
                }}
                className={activeId === heading.id ? 'active' : ''}
              >
                {heading.text}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  )
}

export default OnPageNavigation
